<template>
  <el-dialog
    class="preview-dialog preview-dialog_image"
    :visible.sync="visible"
    @closed="initDialog"
  >
    <el-carousel
      class="carousel-image"
      indicator-position="outside"
      :autoplay="false"
      :initial-index="currentIndex"
    >
      <el-carousel-item
        v-for="(url,index) in urls"
        :key="index"
      >
        <img
          :src="url"
          class="perview-image"
        />
      </el-carousel-item>
    </el-carousel>
  </el-dialog>
</template>

<script>
import preview from "./preview";
export default {
  data() {
    return {
      visible: false,
      urls: [],
      currentIndex: 0
    };
  },
  mounted() {
    preview.$on("open-image", (urls, index = 0) => {
      this.urls = urls;
      this.currentIndex = index;
      this.visible = true;
    });
  },
  methods: {
    initDialog() {
      this.urls = [];
      this.currentIndex = 0;
    }
  }
};
</script>

<style lang="less" scoped>
.preview-dialog_image .el-dialog {
  margin-top: 10vh !important;
}
.carousel-image .el-carousel__container {
  height: 500px;
}
.perview-image {
  display: block;
  margin: 0 auto;
  max-height: 100%;
}
</style>